import {
  Button,
  Form,
  Input,
  Modal,
  Radio,
  Select,
  Skeleton,
  Space,
  Upload,
} from "antd";
import "./styles/activateAccount.css";
import FormItem from "antd/es/form/FormItem";
import { useEffect, useState } from "react";
import {
  CheckCircleFilled,
  DeleteOutlined,
  PaperClipOutlined,
} from "@ant-design/icons";
import config from "../../../config";
import { UserData } from "../../../Context/DataContext";
import { useContext } from "react";
import { LanguageContext } from "../../../Context/changeLanguageProvider";

const base_url = config.base_url;
function ClaimRewards({ open, onOk, onCancel }) {
  const [paymentMethod, setPaymentMethod] = useState("paypal");
  // const [filesForRequest, setFilesForRequest] = useState([]);
  const [largeFile1Error, setLargeFile1Error] = useState(false);
  const [largeFile2Error, setLargeFile2Error] = useState(false);
  const [file1, setFile1] = useState(null);
  const [file2, setFile2] = useState(null);
  const [form] = Form.useForm();
  const bankNameChanged = Form.useWatch("account_onwer_name", form);
  const countryChanged = Form.useWatch("country", form);
  const bicChanged = Form.useWatch("bic", form);
  const ibanChanged = Form.useWatch("iban", form);
  const paypalChanged = Form.useWatch("paypal_account", form);
  const [skeletonLoading, setSkeletonLoading] = useState(true);
  const [successSubmit, setSuccessSubmit] = useState(false);
  const [currency, setCurrency] = useState("eur");
  const [buttonLoading, setButtonLoading] = useState(false);
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  useEffect(() => {
    form.setFieldsValue({
      currency: currency,
      paymentMethod: paymentMethod,
    });
  }, []);
  const setNewValidationData = UserData().setUserValidationData;

  const handleSubmit = () => {
    const validationData = form.getFieldsValue();

    setButtonLoading(true);
    const formData = new FormData();
    if (validationData.paymentMethod === "paypal") {
      formData.append("certificateOfInco", validationData.file_type1.file);
      formData.append("currency", validationData.currency);
      formData.append("billing_method", validationData.paymentMethod);
      formData.append("paypal_account", validationData.paypal_account);
      fetch(base_url + "user/partner/claim/validate", {
        method: "POST",
        mode: "cors",
        credentials: "include",
        body: formData,
      })
        .then((res) => {
          if (res.status === 200) return;
          else {
            throw new Error();
          }
        })
        .then(async (res) => {
          await fetch(base_url + "user/partner/info", {
            method: "POST",
            mode: "cors",
            body: ``,
            headers: {
              Accept: "application/json, text/plain, */*",
              "Content-type": "application/x-www-form-urlencoded",
              credentials: "include",
            },
            credentials: "include",
          })
            .then((res) => res.json())
            .then((res) => {
              setNewValidationData(res);
              console.log(res);
              setSuccessSubmit(true);
              form.resetFields();
              setButtonLoading(false);
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
          setButtonLoading(false);
        });
    } else if (validationData.paymentMethod === "bank") {
      formData.append("certificateOfInco", validationData.file_type1.file);
      formData.append("bank_statement", validationData.file_type2.file);
      formData.append("currency", validationData.currency);
      formData.append("billing_method", validationData.paymentMethod);
      formData.append("bank_owner_name", validationData.account_onwer_name);
      formData.append("bank_country", validationData.country);
      formData.append("bank_bic", validationData.bic);
      formData.append("bank_iban", validationData.iban);
      fetch(base_url + "user/partner/claim/validate", {
        method: "POST",
        mode: "cors",
        credentials: "include",

        body: formData,
      })
        .then(async (res) => {
          await fetch(base_url + "user/partner/info", {
            method: "POST",
            mode: "cors",
            body: ``,
            headers: {
              Accept: "application/json, text/plain, */*",
              "Content-type": "application/x-www-form-urlencoded",
              credentials: "include",
            },
            credentials: "include",
          })
            .then((res) => res.json())
            .then((res) => {
              setNewValidationData(res);
              console.log(res);
              setSuccessSubmit(true);
              form.resetFields();
              setButtonLoading(false);
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          setButtonLoading(false);
          console.log(err);
        });
    }
  };
  return (
    <Modal
      afterOpenChange={(e) => {
        if (e === false) {
          form.resetFields();
          // setFiles([]);
          setSuccessSubmit(false);
          setSkeletonLoading(true);
        }
        if (e === true) {
          form.setFieldsValue({
            currency: "eur",
            paymentMethod: "paypal",
          });
          setPaymentMethod("paypal");
          setSkeletonLoading(false);
          setButtonLoading(false);
        }
      }}
      footer={
        successSubmit
          ? [
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "15px",
                }}
              >
                <Button
                  className="closeButton"
                  onClick={(e) => {
                    onCancel();
                    setSuccessSubmit(false);
                  }}
                >
                  {dublicatedcontent.dublicatedText152}
                </Button>
              </div>,
            ]
          : [
              <Button
                className="cancelButton"
                onClick={(e) => {
                  onCancel();
                  setSuccessSubmit(false);
                }}
              >
                {dublicatedcontent.dublicatedText184}
              </Button>,
              <Button
                loading={buttonLoading}
                className="submitButton"
                onClick={(e) => {
                  form.submit();
                }}
              >
                {dublicatedcontent.submit}
              </Button>,
            ]
      }
      className={successSubmit ? "successModal" : "activateYourAccountModal"}
      open={open}
      onCancel={(e) => {
        onCancel();
      }}
    >
      {successSubmit && (
        <div className="submitSuccess">
          <div className="submitSuccessContent">
            <CheckCircleFilled
              style={{
                fontSize: "24px",
                color: "#419F23",
              }}
            />
            <p
              style={{
                margin: "0",
                fontSize: "26px",
                fontWeight: "500",
              }}
            >
              {dublicatedcontent.dublicatedText155}
            </p>
          </div>
          <div className="activateYourAccountForm_firstRow">
            <p
              style={{
                fontSize: "14px ",
                fontWeight: "400",
              }}
            >
              {dublicatedcontent.dublicatedText154}
            </p>
          </div>
        </div>
      )}
      {!successSubmit && (
        <Skeleton
          paragraph={{
            rows: 20,
          }}
          loading={skeletonLoading}
        >
          <Form
            form={form}
            onFinish={handleSubmit}
            className="activateYourAccountForm"
          >
            <p className="activateYourAccountForm_title">
              {dublicatedcontent.dublicatedText156}
            </p>
            <div className="activateYourAccountForm_firstRow">
              <p>{dublicatedcontent.dublicatedText157}</p>
            </div>
            <FormItem
              labelCol={{ span: 24 }}
              label={`1. ${dublicatedcontent.dublicatedText158} :`}
              name={"currency"}
              className="formSelect"
            >
              <Select
                onChange={(e) => {
                  setCurrency(e);
                }}
              >
                <Select.Option value="eur">EUR</Select.Option>
                <Select.Option value="usd">USD</Select.Option>
                {/* <Select.Option value="aud">AUD</Select.Option>
                <Select.Option value="ca$">CAD</Select.Option>
                <Select.Option value="chf">CHF</Select.Option>
                <Select.Option value="gpb">GPB</Select.Option>
                <Select.Option value="jpy">JPY</Select.Option>
                <Select.Option value="cnh">CNH</Select.Option>
                <Select.Option value="hkd">HKD</Select.Option>
                <Select.Option value="nzd">NZD</Select.Option>
                <Select.Option value="sgd">SGD</Select.Option>
                <Select.Option value="inr">INR</Select.Option>
                <Select.Option value="nok">NOK</Select.Option> */}
              </Select>
            </FormItem>
            <div
              style={{
                position: "relative",
              }}
            >
              <FormItem
                className="formLabel"
                labelCol={{ span: 24 }}
                name="paymentMethod"
                label={`2. ${dublicatedcontent.dublicatedText159} :`}
              >
                <Radio.Group
                  value={paymentMethod}
                  onChange={(e) => {
                    setPaymentMethod(e.target.value);
                    if (paypalChanged) {
                      form.setFieldsValue({
                        account_onwer_name: undefined,
                        country: undefined,
                        bic: undefined,
                        iban: undefined,
                      });
                    }
                    if (
                      bankNameChanged ||
                      countryChanged ||
                      bicChanged ||
                      ibanChanged
                    ) {
                      form.setFieldsValue({
                        paypal_account: undefined,
                      });
                    }
                  }}
                >
                  <Space direction="vertical">
                    <Radio
                      style={
                        paymentMethod === "paypal"
                          ? {
                              marginBottom: "100px",
                            }
                          : {}
                      }
                      value={"paypal"}
                    >
                      {dublicatedcontent.dublicatedText160}
                    </Radio>
                    <Radio value={"bank"}>
                      {dublicatedcontent.dublicatedText161}
                    </Radio>
                  </Space>
                </Radio.Group>
              </FormItem>
              {paymentMethod === "paypal" && (
                <FormItem
                  style={{
                    position: "absolute",
                    top: "65px",
                    left: "25px",
                    width: "44%",
                  }}
                  className="formLabel"
                  labelCol={{ span: 24 }}
                  name="paypal_account"
                  label={dublicatedcontent.dublicatedText162}
                  required
                  validateTrigger="onBlur"
                  rules={[
                    {
                      required: true,
                      message: dublicatedcontent.dublicatedText163,
                    },
                    {
                      type: "email",
                      message: dublicatedcontent.dublicatedText164,
                    },
                  ]}
                >
                  <Input className="formInput" />
                </FormItem>
              )}
              {paymentMethod === "bank" && (
                <>
                  <FormItem
                    style={{
                      width: "44%",
                      transform: "translateX(25px)",
                    }}
                    className="formLabel"
                    labelCol={{ span: 24 }}
                    name="account_onwer_name"
                    label={dublicatedcontent.dublicatedText165}
                    required
                    rules={[
                      {
                        required: true,
                        message: dublicatedcontent.dublicatedText166,
                      },
                    ]}
                  >
                    <Input className="formInput" />
                  </FormItem>
                  <div
                    style={{
                      display: "flex",
                      width: "93%",
                      gap: "25px",
                      transform: "translateX(25px)",
                    }}
                  >
                    <FormItem
                      style={{
                        width: "100%",
                      }}
                      className="formLabel"
                      labelCol={{ span: 24 }}
                      name="country"
                      label={dublicatedcontent.dublicatedText167}
                      required
                      rules={[
                        {
                          required: true,
                          message: dublicatedcontent.dublicatedText168,
                        },
                      ]}
                    >
                      <Input className="formInput" />
                    </FormItem>
                    <FormItem
                      style={{
                        width: "100%",
                      }}
                      className="formLabel"
                      labelCol={{ span: 24 }}
                      name="bic"
                      label={dublicatedcontent.dublicatedText170}
                      required
                      rules={[
                        {
                          required: true,
                          message: dublicatedcontent.dublicatedText171,
                        },
                      ]}
                    >
                      <Input className="formInput" />
                    </FormItem>
                  </div>
                  <FormItem
                    style={{
                      width: "93%",
                      transform: "translateX(25px)",
                    }}
                    className="formLabel"
                    labelCol={{ span: 24 }}
                    name="iban"
                    label={dublicatedcontent.dublicatedText172}
                    required
                    rules={[
                      {
                        required: true,
                        message: dublicatedcontent.dublicatedText173,
                      },
                    ]}
                  >
                    <Input className="formInput" />
                  </FormItem>
                </>
              )}
            </div>
            <div>
              <p
                style={{
                  margin: "0",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                3.{dublicatedcontent.dublicatedText174}
              </p>
              <p
                style={{
                  fontSize: "14px",
                  color: "#858585",
                  margin: "-2px 0 0 15px",
                }}
              >
                {dublicatedcontent.dublicatedText175}
              </p>
              <Form.Item
                style={{
                  marginLeft: "15px",
                }}
                className="formLabel"
                labelCol={{ span: 24 }}
                name={"file_type1"}
                label={dublicatedcontent.dublicatedText176}
                required
                rules={[
                  // {
                  //   required: true,
                  //   message: dublicatedcontent.dublicatedText177,
                  // },
                  {
                    validateTrigger: "onSubmit",
                    required: true,
                    validator: (_, value) => {
                      if (file1) {
                        return Promise.resolve();
                      } else if (!file1 && !largeFile1Error) {
                        return Promise.reject(
                          new Error(dublicatedcontent.dublicatedText177)
                        );
                      } else return Promise.reject(new Error());
                    },
                  },
                ]}
              >
                <Upload
                  itemRender={(originNode, file, fileList, { remove }) => {
                    if (largeFile1Error) return;
                    return (
                      <div className="uploadListWrapper">
                        <PaperClipOutlined
                          style={{ color: "#0091EA", marginRight: "15px" }}
                        />
                        <p
                          style={{
                            color: "#0091EA",
                            position: "relative",
                            left: 0,
                            margin: "0 15px 0 0 ",
                            top: 0,
                          }}
                        >
                          {file.name}
                        </p>
                        <span>|</span>
                        <div
                          style={{
                            display: "flex",
                            margin: "0 0 0 15px ",
                            color: "#B20606",
                          }}
                          onClick={() => remove(file)}
                        >
                          <DeleteOutlined
                            style={{
                              margin: "0 5px 0 auto",
                            }}
                          />
                          <p
                            style={{
                              margin: 0,
                            }}
                          >
                            {dublicatedcontent.dublicatedText178}
                          </p>
                        </div>
                      </div>
                    );
                  }}
                  multiple={false}
                  style={{
                    width: "150px",
                  }}
                  maxCount={1}
                  accept=".pdf, .jpg, .jpeg, .png"
                  beforeUpload={(file, remove) => {
                    const isLt5M = file.size / 1024 / 1024 <= 5;
                    if (!isLt5M) {
                      console.log("File exceeds max size 1");
                      //   alert("Image must smaller than 5MB!");
                      setLargeFile1Error(true);
                      remove(file);
                      setFile1(null);
                      return false;
                    }
                    setFile1(file);
                    setLargeFile1Error(false);
                    const reader = new FileReader();
                    // setFiles((prev) => [...prev, file]);

                    // setFilesForRequest((prev) => [
                    //   ...prev,
                    //   { fileType: "certificateOfInco", fileName: file.name },
                    // ]);

                    // reader.onload = (e) => {};

                    // Prevent upload
                    return false;
                  }}
                  onRemove={(e) => {
                    setFile1(null);
                    setLargeFile1Error(false);
                    form.setFieldsValue({
                      file_type1: undefined,
                    });
                    // setFilesForRequest((prev) => {
                    //   return prev.filter((file) => {
                    //     return file.fileName !== e.name;
                    //   });
                    // });
                    // setFiles((prev) => {
                    //   return prev.filter((file) => file.name !== e.name);
                    // });
                  }}
                >
                  <Button
                    style={{
                      position: "relative",
                    }}
                  >
                    {dublicatedcontent.dublicatedText179}
                  </Button>
                  {largeFile1Error && (
                    <p
                      style={{
                        margin: "10px 0 0 0 ",
                        color: "#FF0000",
                        fontSize: "14px",

                        fontWeight: 400,
                      }}
                    >
                      {dublicatedcontent.dublicatedText180}
                    </p>
                  )}
                </Upload>
              </Form.Item>
              {paymentMethod === "bank" && (
                <Form.Item
                  style={{
                    marginLeft: "15px",
                  }}
                  className="formLabel"
                  labelCol={{ span: 24 }}
                  name={"file_type2"}
                  label={dublicatedcontent.dublicatedText181}
                  required
                  rules={[
                    {
                      validateTrigger: "onSubmit",
                      required: true,
                      validator: (_, value) => {
                        if (file2) {
                          return Promise.resolve();
                        } else if (!file2 && !largeFile2Error) {
                          return Promise.reject(
                            new Error(dublicatedcontent.dublicatedText177)
                          );
                        } else return Promise.reject(new Error());
                      },
                    },
                    // {
                    //   required: true,
                    //   message: dublicatedcontent.dublicatedText177,
                    // },
                  ]}
                >
                  <Upload
                    multiple={false}
                    style={{
                      width: "150px",
                    }}
                    itemRender={(originNode, file, fileList, { remove }) => {
                      if (largeFile2Error) return;
                      return (
                        <div className="uploadListWrapper">
                          <PaperClipOutlined
                            style={{ color: "#0091EA", marginRight: "15px" }}
                          />
                          <p
                            style={{
                              color: "#0091EA",
                              position: "relative",
                              left: 0,
                              margin: "0 15px 0 0 ",
                              top: 0,
                            }}
                          >
                            {file.name}
                          </p>
                          <span>|</span>
                          <div
                            style={{
                              display: "flex",
                              margin: "0 0 0 15px ",
                              color: "#B20606",
                            }}
                            onClick={() => remove(file)}
                          >
                            <DeleteOutlined
                              style={{
                                margin: "0 5px 0 auto",
                              }}
                            />
                            <p
                              style={{
                                margin: 0,
                              }}
                            >
                              {dublicatedcontent.dublicatedText178}
                            </p>
                          </div>
                        </div>
                      );
                    }}
                    maxCount={1}
                    accept=".pdf, .jpg, .jpeg, .png"
                    beforeUpload={(file) => {
                      const isLt5M = file.size / 1024 / 1024 <= 5;
                      setLargeFile2Error(false);
                      if (!isLt5M) {
                        console.log("File exceeds max sizev2");
                        //   alert("Image must smaller than 5MB!");
                        setLargeFile2Error(true);
                        setFile2(null);
                        return false;
                      } else {
                        const reader = new FileReader();
                        setFile2(file);
                        // setFiles((prev) => [...prev, file]);

                        // setFilesForRequest((prev) => [
                        //   ...prev,
                        //   {
                        //     fileType: "certificateOfInco",
                        //     fileName: file.name,
                        //   },
                        // ]);

                        reader.onload = (e) => {};

                        // Prevent upload
                        return false;
                      }
                    }}
                    onRemove={(e) => {
                      setLargeFile2Error(false);
                      form.setFieldsValue({
                        file_type1: undefined,
                      });
                      setFile2(null);
                      // setFilesForRequest((prev) => {
                      //   return prev.filter((file) => {
                      //     return file.fileName !== e.name;
                      //   });
                      // });
                      // setFiles((prev) => {
                      //   return prev.filter((file) => file.name !== e.name);
                      // });
                    }}
                  >
                    <Button
                      style={{
                        width: "100%",
                        position: "relative",
                      }}
                    >
                      {dublicatedcontent.dublicatedText179}
                    </Button>
                    {largeFile2Error && (
                      <p
                        style={{
                          margin: "10px 0 0 0 ",
                          color: "#FF0000",
                          fontSize: "14px",

                          fontWeight: 400,
                        }}
                      >
                        {dublicatedcontent.dublicatedText180}
                      </p>
                    )}
                  </Upload>
                </Form.Item>
              )}
            </div>
            <div>
              <p
                style={{
                  margin: "0",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                4.{dublicatedcontent.dublicatedText182}
              </p>
              <p
                style={{
                  fontSize: "14px",
                  color: "#858585",
                  margin: "-2px 0 0 15px",
                }}
              >
                {dublicatedcontent.dublicatedText183}
              </p>
            </div>
          </Form>
        </Skeleton>
      )}
    </Modal>
  );
}

export default ClaimRewards;
